import React from "react";
import { graphql } from "gatsby";
import Layout from "@qlik/qlik/src/components/Layout";
import Seo from "@qlik/qlik/src/components/Seo";
import { renderLinkedComponents } from "@qlik/qlik/src/components/registry";
import BlogTemplate from "@qlik/qlik/src/components/InnerPages/Blog";
import HeroBannerBlog from "@qlik/qlik/src/components/CardContainer/Hero_Banner_Blog";
import { BLOG_PATHNAME } from "@qlik/qlik/gatsbyNode/constants";

/**
 * GraphQL query to retrieve all data for the flexible page.
 * Gatsby only allows one dynamic query per page.
 */
export const query = graphql`
    query($id: String) {
        contentfulHeader: contentfulHeader(name: { eq: "Header" }) {
            ...Header
        }
        contentfulBlog(id: { eq: $id }) {
            ...Blog
        }
        contentfulFooter(name: { eq: "Full footer" }) {
            ...Footer
        }
        contentfulThemeSettings {
            ...ThemeSettings
        }
    }
`;

/**
 * Blog component
 * This component retrieves components from the registry based on content type and rendering name
 * @param {Object} data - The data object returned from the GraphQL query
 * @returns {JSX.Element} - The rendered Blog component
 */
const Blog = ({ data }) => {
    const { blogMicrocopyGroup } = data?.contentfulThemeSettings || {};
    // This renders the inner page data inside the page template component
    const bodyContent = <BlogTemplate data={{ ...data.contentfulBlog, microcopyGroup: blogMicrocopyGroup }} />;
    const pageComponents = data.contentfulBlog.components?.map((el, i) => renderLinkedComponents(el, i));

    return (
        <Layout
            headerData={data.contentfulHeader}
            minimalHeaderData={data.contentfulThemeSettings?.minimalNavPages}
            footerData={data.contentfulFooter}
            pageSlug={data.contentfulBlog.slug}
            dynamicHeaderCta={data.contentfulThemeSettings?.dynamicHeaderCta}
            searchPopupData={data.contentfulThemeSettings?.searchPopupMicrocopyGroup}
        >
            <Seo
                data={data.contentfulBlog.metadata}
                pageSlug={`${BLOG_PATHNAME}${data.contentfulBlog.slug?.startsWith("/") ? "" : "/"}${
                    data.contentfulBlog.slug
                }`}
            />
            <HeroBannerBlog data={data} />
            {bodyContent}
            {pageComponents}
        </Layout>
    );
};
export default Blog;
